import {
  STYLING_VALUE_FONT_STYLE_ITALIC,
  STYLING_VALUE_FONT_WEIGHT_BOLD,
  STYLING_VALUE_TEXT_DECORATION_UNDERLINE,
} from 'sharedParts';

export const isFontItalic = fontStyle =>
  fontStyle === STYLING_VALUE_FONT_STYLE_ITALIC;

export const isFontBold = fontWeight =>
  fontWeight === STYLING_VALUE_FONT_WEIGHT_BOLD;

export const isTextUnderlined = textDecoration =>
  textDecoration === STYLING_VALUE_TEXT_DECORATION_UNDERLINE;
